var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3694_34407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.918 4.16478C15.0896 4.57979 15.419 4.90968 15.8337 5.08191L17.288 5.68433C17.7031 5.85625 18.0328 6.18601 18.2047 6.60107C18.3767 7.01612 18.3767 7.48247 18.2047 7.89753L17.6027 9.35085C17.4307 9.7661 17.4305 10.2329 17.6033 10.6479L18.2042 12.1009C18.2894 12.3064 18.3333 12.5268 18.3333 12.7493C18.3334 12.9719 18.2896 13.1922 18.2044 13.3978C18.1192 13.6034 17.9944 13.7902 17.8371 13.9475C17.6797 14.1049 17.4928 14.2297 17.2872 14.3148L15.834 14.9168C15.4189 15.0884 15.0891 15.4178 14.9168 15.8325L14.3144 17.2869C14.1425 17.7019 13.8128 18.0317 13.3977 18.2036C12.9827 18.3755 12.5164 18.3755 12.1013 18.2036L10.6481 17.6016C10.233 17.4301 9.76683 17.4304 9.35208 17.6026L7.89773 18.2042C7.48292 18.3757 7.017 18.3755 6.6023 18.2038C6.1876 18.0319 5.85803 17.7026 5.686 17.288L5.08343 15.8332C4.91183 15.4182 4.58244 15.0883 4.1677 14.916L2.71338 14.3136C2.29852 14.1418 1.96888 13.8122 1.79689 13.3974C1.62492 12.9826 1.62468 12.5164 1.79624 12.1014L2.39821 10.6482C2.5697 10.2331 2.56935 9.76693 2.39724 9.3521L1.79613 7.89667C1.71091 7.6911 1.66703 7.47075 1.66699 7.24821C1.66696 7.02568 1.71077 6.80531 1.79593 6.59971C1.88108 6.39412 2.00592 6.20731 2.1633 6.04998C2.32068 5.89264 2.50751 5.76787 2.71313 5.68277L4.16641 5.08078C4.58105 4.90933 4.91073 4.58035 5.08308 4.16607L5.68548 2.71169C5.85739 2.29663 6.18714 1.96688 6.60218 1.79496C7.01722 1.62303 7.48355 1.62303 7.89859 1.79496L9.35183 2.39695C9.76691 2.56844 10.2331 2.56809 10.6479 2.39598L12.1028 1.79589C12.5178 1.62407 12.984 1.6241 13.399 1.79599C13.8139 1.96788 14.1437 2.29754 14.3156 2.71248L14.9182 4.16729L14.918 4.16478Z",
    fill: "#28B116",
    stroke: "#28B116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 9.99984L9.16667 11.6665L12.9167 7.9165",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3694_34407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.7861ce79fc536e6c1962e4a3b0749c84.svg";
export { ForwardRef as ReactComponent };